module.exports = __webpack_public_path__ + "img/checked.977c8aed.svg";